import generatedArchiveTastePrompts from "../../../data/archive-taste-prompts.json";

import { ARCHIVE_TASTE_PROMPT_SURFACES } from "./archiveTastePromptConfig.js";

function validPromptList(value) {
  return Array.isArray(value)
    ? value.map((prompt) => String(prompt || "").trim()).filter(Boolean)
    : [];
}

export function getArchiveTastePrompts(surfaceKey) {
  const generated = validPromptList(generatedArchiveTastePrompts?.prompts?.[surfaceKey]);
  if (generated.length > 0) {
    return generated;
  }

  return validPromptList(ARCHIVE_TASTE_PROMPT_SURFACES[surfaceKey]?.fallbackPrompts);
}
